const initialState = {
  apiPlans: [],
  apiPlan: {},
  validationError: {},
  approvedUsers: [],
  orgGrps: [],
  updateApiPlanError: '',
  deletePlanError: '',
  updatedPricingStatus: [],
  isShowSuccessMsg: false
};

const PricingPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_API_PLANS':
      return { ...state, apiPlans: action.payload };
    case 'CREATE_API_PLAN':
      return { ...state, apiPlan: action.payload };
    case 'UPDATE_API_PLAN':
      return { ...state, apiPlan: action.payload };
    case 'UPDATE_API_PLAN_STATUS':
      return { ...state, apiPlan: action.payload };
    case 'UPDATE_API_PLAN_ERROR':
      return { ...state, updateApiPlanError: action.error };
    case 'DELETE_PLAN':
      return { ...state, apiPlan: action.payload };
    case 'DELETE_PLAN_ERROR':
      return { ...state, deletePlanError: action.error };
    case 'VALIDATION_ERROR':
      return { ...state, validationError: action.error };
    case 'RESET_PLAN':
      return { ...state, apiPlans: [] };
    case 'APPROVED_USERS':
      return { ...state, approvedUsers: action.payload };
    case 'ORG_GROUPS':
      return { ...state, orgGrps: action.payload };
    case 'UPDATE_PRICING_STATUS':
      return { ...state, updatedPricingStatus: action.payload };
    case 'SHOW_SUCCESS_MESSAGE':
      return { ...state, isShowSuccessMsg: action.payload };
    default:
      return state;
  }
};

export default PricingPlanReducer;
